import 'babel-polyfill'; 

import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import "typeface-fanwood-text";
import "@babel/polyfill";

ReactDOM.render(
        <App />
, document.getElementById('root'));
serviceWorker.unregister();
